// Build-time configuration for the super-admin portal.
// Values come from .env (REACT_APP_*), with safe defaults for local dev.

const envWhitelist = (process.env.REACT_APP_WHITELISTED_IDS || '')
  .split(',')
  .map((id) => id.trim())
  .filter(Boolean);

export const config = {
  api: {
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5050'
  },
  app: {
    name: process.env.REACT_APP_NAME || 'Lushin Admin',
    environment: process.env.REACT_APP_ENVIRONMENT || 'development'
  },
  auth: {
    /**
     * Firebase UIDs allowed into the super-admin portal. Sourced from
     * REACT_APP_WHITELISTED_IDS; falls back to a built-in default so a
     * misconfigured env never silently locks everyone out in dev.
     * Must stay in sync with backend-tenant WHITELISTED_IDS.
     *
     * ⚠️ The fallback has to be a uid that exists in THIS fork's Firebase
     * project (`lushin-apexia`), or it does the exact opposite of what it says.
     * It was `xGNSfyYFhGOsFAqqsVXLGywXuW73` — inherited from SalesGuru and
     * `auth/user-not-found` here — so a build with the env var missing locked
     * out everyone rather than nobody. Fixed 2026-08-10.
     */
    whitelistedIds: envWhitelist.length
      ? envWhitelist
      : ['m43dy72tV0f5XEGHhZ7XkGgUAR62']
  }
};

export function isWhitelisted(uid: string | null | undefined): boolean {
  return Boolean(uid && config.auth.whitelistedIds.includes(uid));
}
